module.exports = __webpack_public_path__ + "media/images/globe-ebadf089c3cd34650590976d7a8e0d07.svg";